import { ReferralGiftApi } from '../../generated/api';
import configuration from './configuration';

export const referralGiftService = new ReferralGiftApi(configuration);
